import React from 'react';
import '../../styles/CaseStudyFour/CaseStudiesBeginning4.css';
import productIcon1 from '../../assets/magnifying-glass-icon.png';
import productIcon2 from '../../assets/salesforce.png';
import productIcon3 from '../../assets/purple-a.png';

const SectionBeginning4 = () => {
  return (
    <section className="beginning-section4">
      <div className="beginning-container4">
        {/* Title */}
        <h2 className="beginning-title4">The Beginning</h2>

        {/* Product/Service Boxes */}
        <div className="product-service-container4">
          <div className="product-service-box4">
            <img src={productIcon1} alt="Product 1" className="beginning-product-icon4" />
            <p>End-To-End Tracking</p>
          </div>
          <div className="product-service-box">
            <img src={productIcon2} alt="Product 2" className="beginning-product-icon4" />
            <p>Salesforce CRM Data Integration</p>
          </div>
          <div className="product-service-box">
            <img src={productIcon3} alt="Product 3" className="beginning-product-icon4" />
            <p>Google Ads Optimization</p>
          </div>
        </div>

        {/* Description Text */}
        <p className="beginning-description4">
          John Volken Academy Movers, base in Kent, Washington, and Phoenix, Arizona, offers high-quality moving services. 
          To improve the efficiency of their Google Ads campaigns, we implemented End-To-End Tracking. This system pulls key data from their Salesforce CRM and feeds it back into Google Ads. 
          With this real-time data, we were able to identify which clicks, campaigns, and keywords resulted in scheduled moves and valid leads.
           By focusing on actual moves instead of leads alone, we optimized their marketing spend for meaningful results.
        </p>

      </div>
    </section>
  );
};

export default SectionBeginning4;

